import DefaultLink from '@/components/common/default/DefaultLink';
import useTypedTranslation from '@/hooks/useTypedTranslation';
import { HeaderEnum } from '@/types/translations/HeaderEnum';
import { AlgoliaSku } from '@/types/algolia';
import { memo } from 'react';
import { UseHitsProps } from 'react-instantsearch';
import { SkuMainImage } from '@/utilites/get-sku-main-image';
import { HiOutlineChevronRight } from 'react-icons/hi';
import SkuDescription from '@/components/skuDescription';

function HeaderHit({ item }: { item: AlgoliaSku }) {
  const { translate } = useTypedTranslation<HeaderEnum>('header');

  return (
    <li key={item.objectID} className="tw-group">
      <DefaultLink
        className="tw-block tw-px-4 tw-py-3 tw-transition-colors tw-duration-150 hover:tw-bg-gray-50"
        href={`/${item.slug}`}
        aria-label={translate(HeaderEnum['go_to_sku_name']).replace('{{skuName}}', item.name)}
      >
        <div className="tw-flex tw-items-center">
          <div className="tw-flex tw-h-8 tw-w-8 tw-shrink-0 tw-items-center tw-justify-center">
            <span className="tw-text-xs tw-font-medium tw-text-gray-500">{item.__position}</span>
          </div>

          <div className="tw-relative tw-flex-shrink-0 tw-rounded-lg tw-border tw-border-gray-200 tw-bg-gray-50 tw-p-2">
            <SkuMainImage
              src={item.mainImageUrl}
              alt={item.name}
              width={48}
              height={48}
              className="tw-object-contain"
            />
          </div>
          <div className="tw-ml-4 tw-min-w-0 tw-flex-1 tw-text-left">
            <p
              className="tw-mb-0.5 tw-truncate tw-text-sm tw-font-medium tw-text-gray-900"
              dangerouslySetInnerHTML={{
                __html: item._highlightResult.name.value,
              }}
            ></p>
            <p className="tw-mb-0.5 tw-truncate tw-text-xs tw-text-gray-600">
              {item.brand?.name} {item.category?.name && `- ${item.category.name}`}
            </p>
            <p className="tw-truncate tw-text-xs tw-text-gray-500">
              <SkuDescription
                skuBottleSizeInMl={item.bottleSizeInMl}
                skuReleaseDate={item.releaseDate}
                skuVolumeInPercent={item.volumeInPercent}
              />
            </p>
          </div>

          <div className="tw-ml-2 tw-flex-shrink-0">
            <HiOutlineChevronRight className="tw-h-5 tw-w-5 tw-text-gray-400 tw-transition-colors group-hover:tw-text-gray-600" />
          </div>
        </div>
      </DefaultLink>
    </li>
  );
}

export default memo(HeaderHit);
